import { APITransport } from '@client/transports/api';

export const PluginsService = {
  getAll() {
    return APITransport.get({
      path: '/rest/domain/plugins'
    });
  },
  async getById(rule) {
    const response = await APITransport.get({
      path: '/rest/domain/plugins'
    });

    return response.find(({ rulename }) => rulename === rule);
  },
  async savePlugin(body = {}) {
    return APITransport.post({
      path: 'rest/domain/save/plugins',
      body
    });
  },
  async deletePlugin(body = {}) {
    return APITransport.post({
      path: 'rest/domain/delete/plugins',
      body
    });
  },
  async getDiagnostics(id, recipient) {
    return APITransport.get({
      path: `/rest/domain/plugins/${id}/execute`,
      query: {
        sgrecipient: recipient
      }
    });
  }
};
